import { Trans } from '@lingui/react/macro'

import { PrimaryButton } from '../../_components/PrimaryButton'
import style from '../../_components/H2/index.module.scss'


import { cls } from 'tagged-classnames-free';
export const Cta: React.FC = () => {
  return (
    <div className='relative z-[1] mx-auto flex max-w-[1032px] flex-col items-center px-4 pb-12 md:pb-[110px]'>
      <span
        style={{
          background:
            'linear-gradient(360deg, rgba(201, 175, 255, 0.2) 0%, rgba(121, 105, 153, 0.2) 100%)',
        }}
        className='text-f-other-9 mx-auto block w-fit rounded-full border border-[#C9AFFF33] px-5 py-1.5 text-xs md:text-sm'
      >
        <Trans>Tad.ai</Trans>
      </span>
      <h2
        className={cls`pt-3 text-center text-2xl font-bold md:pt-6 md:text-[64px] md:leading-[80px] ${style.heightLightText}`}
      >
        <Trans>Create AI Music for Free Today With Tad AI!</Trans>
      </h2>
      <p className='text-f-other-10 pt-2 text-center text-sm md:pt-6 md:text-xl'>
        <Trans>
          With Tad AI music generator, you can easily create high-quality,
          royalty-free music that suits your needs!
        </Trans>
      </p>
      <PrimaryButton href='/ai-music-generator' className='mt-6 md:mt-12'>
        <Trans>Create AI songs for free</Trans>
      </PrimaryButton>
    </div>
  )
}
